import React from 'react'
import { Main, MainBody, MainTop, MainTopTitle } from '@/components/Layout'
import ReportSubmissionGroupGrid from '@/components/reporting/reportSubmissionGroupGrid'
import Resx from '@/components/Resx'

class ForecastReportSubmissionGroup extends React.Component {
  render () {
    return (
      <Main>
        <MainTop>
          <MainTopTitle>
            <Resx name='Reporting.ForecastReportGroupSubmissionsTitle' />
          </MainTopTitle>
        </MainTop>
        <MainBody>
          <ReportSubmissionGroupGrid forecasting detailUrlFormat='/forecast-report-submission-groups/{0}/report-submissions' />
        </MainBody>
      </Main>
    )
  }
}

export default ForecastReportSubmissionGroup



// WEBPACK FOOTER //
// ./src/report-app/pages/reporting/forecastReportSubmissionGroup.js